import { ScheduleTime } from '@src/core/buyerApiClient';

export type RescheduleStepsType = 'date' | 'time' | 'summary';

type ActionProps =
  | {
      type: 'RESCHEDULE/SELECT_DATE';
      payload: string;
    }
  | {
      type: 'RESCHEDULE/SELECT_TIME';
      payload: ScheduleTime;
    }
  | {
      type: 'RESCHEDULE/RESET_FIELDS';
    }
  | {
      type: 'RESCHEDULE/SET_CURRENT_STEP';
      payload?: RescheduleStepsType;
    };

type StateProps = {
  date?: string;
  visible: boolean;
  time?: ScheduleTime;
  currentStep: RescheduleStepsType | undefined;
  steps: RescheduleStepsType[];
};

export const initialState: StateProps = {
  date: undefined,
  time: undefined,
  currentStep: 'date',
  steps: ['date', 'time', 'summary'],
  visible: true,
};

function reducer(state: StateProps, action: ActionProps) {
  const newState = { ...state };

  switch (action.type) {
    case 'RESCHEDULE/SELECT_DATE': {
      newState.date = action.payload;

      return newState;
    }

    case 'RESCHEDULE/SELECT_TIME': {
      newState.time = action.payload;

      return newState;
    }

    case 'RESCHEDULE/RESET_FIELDS': {
      return { ...initialState, visible: false };
    }

    case 'RESCHEDULE/SET_CURRENT_STEP': {
      newState.currentStep = action.payload;

      return newState;
    }
    default:
      return state;
  }
}

export default reducer;
